import { setAppDynamicsUserData } from '@elliemae/pui-app-sdk';

setAppDynamicsUserData({ loanId: '1234' });
